// extracted by mini-css-extract-plugin
export default {"shadow":"WE9RL44NUwU80AMD3fZ2"};